module.exports = __webpack_public_path__ + "74b438f7d46414fa7e7dbe2f26c56525.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CI.svg
// module id = HIIy
// module chunks = 0